function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14",
  transform: "translate(0.5 -77.939)"
}, React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(0 87.411)"
}, React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M25.2,235.318H1.061a1.028,1.028,0,1,0,0,2.055H25.2a1.028,1.028,0,1,0,0-2.055Z",
  transform: "translate(0 -235.318)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))), React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(0 78.439)"
}, React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M25.2,78.439H1.061a1.028,1.028,0,1,0,0,2.055H25.2a1.028,1.028,0,1,0,0-2.055Z",
  transform: "translate(0 -78.439)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))), React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(0 96.384)"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M25.2,392.2H1.061a1.028,1.028,0,1,0,0,2.055H25.2a1.028,1.028,0,1,0,0-2.055Z",
  transform: "translate(0 -392.197)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27.265,
    height: 21,
    viewBox: "0 0 27.265 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu.8a741aa2.svg";
export { ForwardRef as ReactComponent };